export default __webpack_public_path__ + "static/media/köide-32-33.8c4b5505.png";